import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

export interface ProgrammesCountQuery {
  group_by?: string;
}
export interface DistrictsCountQuery {
  group_by?: string;
}
export interface FacilitiesCountQuery {
    group_by?: string;
}

const getRegionCount = async () => {
  return apiService.apiRequest<Record<string, number>>(
    "get",
    `regions/analytics/count`
  );
};

const getDivisionCount = async () => {
  return apiService.apiRequest<Record<string, number>>(
    "get",
    `divisions/analytics/count`
  );
};

const getProgrammesCount = async (queryParams?: ProgrammesCountQuery) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<Record<string, number>>(
    "get",
    `programmes/analytics/count${query}`
  );
};

const getDistrictsCount = async (queryParams?: DistrictsCountQuery) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<Record<string, number>>(
    "get",
    `districts/analytics/count${query}`
  );
};


const getFacilitiesCount = async (queryParams?: FacilitiesCountQuery) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<Record<string, number>>(
    "get",
    `facilities/analytics/count${query}`
  );
};

export const domainAnalytics = {
  getRegionCount,
  getDivisionCount,
  getProgrammesCount,
  getDistrictsCount,
  getFacilitiesCount,
};
